import { notification as antdNotification } from 'antd'

export const notification = {
  success: ({
    message,
    description,
    duration = 3,
  }: { message: string; description?: string; duration?: number }) => {
    antdNotification.config({
      duration,
    })
    antdNotification.success({
      message,
      description,
    })
  },
  error: ({
    message,
    description,
    duration = 4.5,
  }: { message: string; description?: string; duration?: number }) => {
    antdNotification.config({
      duration,
    })
    antdNotification.error({
      message,
      description,
    })
  },
}
